<template>
  <span>
    <v-btn @click="showDialog" icon color="primary">
      <v-icon>mdi-account-details</v-icon>
    </v-btn>

    <!-- TODO: rename showDialog and closeDialog -->
    <permissions-dialog
      :showDialog="isDialogVisible"
      :permissions="permissions"
      :roleId="roleId"
      :selectedPermissionsIds="permissionsIds"
      @close="closeDialog"
      v-if="isDialogVisible"
    />
  </span>
</template>

<script>
import { mapState } from 'vuex';
import PermissionsDialog from './PermissionsDialog.vue';
import permissionsApi from '../../services/permissions.api';

export default {
  components: { PermissionsDialog },
  props: {
    roleId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    isDialogVisible: false,
    permissionsIds: [],
  }),
  computed: {
    ...mapState('roles', ['permissions']),
  },
  methods: {
    async showDialog() {
      // Fetch permissionsa assigned to the role
      this.permissionsIds = await permissionsApi.getRolePermissions(this.roleId);
      this.isDialogVisible = true;
    },
    closeDialog() {
      this.isDialogVisible = false;
    },
  },
}
</script>